import React from 'react';

import { ICustomOptionProps } from 'common/components/FieldGenerator/types';
import classNames from 'classnames';
import { useTranslateFn } from 'utils/useTranslateFn';
import { TranslationKey } from '@danfloss/utils/text-translations';
import CachedImage from 'common/components/CachedImage';
import styles from './styles.module.scss';

const FittingOption = React.memo(({
  option: { title, attributes },
}: ICustomOptionProps) => {
  const t = useTranslateFn<TranslationKey>();
  const defaultImageFitting = t('variables.fittingNoImage');
  const attrs = (attributes || {}) as Record<string, string>;
  const attrCount = [title, attrs?.description].filter((v) => !!v).length;
  const gridClass = classNames({
    [styles.content]: true,
    [styles.content2]: attrCount === 1,
    [styles.content3]: attrCount === 2,
  });
  return (
    <>
      <div className={styles.image}>
        <CachedImage
          src={attributes?.image || defaultImageFitting}
          alt={title}
        />
      </div>
      <div className={gridClass}>
        <span>{title}</span>
        {attrs?.description
        && (
          <span className={styles.more}>
            {`${attrs?.description}`}
          </span>
        )}
      </div>
    </>
  );
}, (prevProps, nextProps) => (
  prevProps.option.id === nextProps.option.id
  && prevProps.option.title === nextProps.option.title
  && prevProps.option.attributes?.image === nextProps.option.attributes?.image
  && prevProps.option.attributes?.description === nextProps.option.attributes?.description
));

FittingOption.displayName = 'FittingOption';

export default FittingOption;
